<script setup lang="ts">
  import type { HTMLAttributes } from 'vue';

  import { cn } from '@ui/utils/utils';

  const props = defineProps<{
    class?: HTMLAttributes['class'];
  }>();
</script>

<template>
  <p data-slot="card-description" :class="cn('text-muted-foreground text-xs', props.class)">
    <slot />
  </p>
</template>
